import { render, staticRenderFns } from "./ManufacturerOpenPurchasesReport.vue?vue&type=template&id=22d98b97&"
import script from "./ManufacturerOpenPurchasesReport.vue?vue&type=script&lang=js&"
export * from "./ManufacturerOpenPurchasesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports